export const getYesterday = (day) => {
    let newDate = new Date(day);
    newDate.setDate(newDate.getDate() - 1);
    return new Date(newDate);
}

export const getTomorrow = (day) => {
    let newDate = new Date(day);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
}

export const getFromYesterday = (day) => {
    let newDate = new Date(day);
    newDate.setDate(newDate.getDate() - 1);
    newDate.setHours(0, 0, 0);
    return newDate;
}

export const getToYesterday = (day) => {
    let newDate = new Date(day);
    newDate.setDate(newDate.getDate() - 1);
    newDate.setHours(23, 59, 59);
    return newDate;
}

export const getFirstDayOfWeek = (day) => {
    let newDate = new Date(day);
    newDate.setDate(newDate.getDate() - newDate.getDay() + 1);
    newDate.setHours(0, 0, 0);
    return newDate;
}

export const getLastDayOfWeek = (day) => {
    let newDate = new Date(day);
    newDate.setDate(newDate.getDate() - newDate.getDay() + 7);
    newDate.setHours(23, 59, 59);
    return newDate;
}

export const getFirstDayOfLastWeek = (day) => {
    let newDate = new Date(day);
    newDate.setDate(newDate.getDate() - newDate.getDay() - 6);
    newDate.setHours(0, 0, 0);
    return newDate;
}

export const getLastDayOfLastWeek = (day) => {
    let newDate = new Date(day);
    newDate.setDate(newDate.getDate() - newDate.getDay());
    newDate.setHours(23, 59, 59);
    return new Date(newDate);
}

export const getFirstDayOfThisMonth = (day) => {
    let newDate = new Date(day);
    newDate.setDate(1);
    newDate.setHours(0, 0, 0);
    return new Date(newDate);
}

export const getLastDayOfThisMonth = (day) => {
    let newDate = new Date(day);
    newDate.setMonth(newDate.getMonth() + 1);
    newDate.setDate(1);
    newDate.setDate(newDate.getDate() - 1)
    newDate.setHours(23, 59, 59);
    return new Date(newDate);
}

export const getFirstDayOfLastMonth = (day) => {
    let newDate = new Date(day);
    newDate.setMonth(newDate.getMonth() - 1);
    newDate.setDate(1);
    newDate.setHours(0, 0, 0);
    return new Date(newDate);
}

export const getLastDayOfLastMonth = (day) => {
    let newDate = new Date(day);
    newDate.setDate(1);
    newDate.setDate(newDate.getDate() - 1)
    newDate.setHours(23, 59, 59);
    return new Date(newDate);
}

function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}


export function calcBusinessDays(startDate, endDate) {
    var count = 0;
    var curDate = startDate;
    while (curDate <= endDate) {
        var dayOfWeek = curDate.getDay();
        var isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0);
        if (!isWeekend)
            count++;
        curDate = addDays(curDate, 1);
    }
    return count;
}

export function calcDays(startDate, endDate) {
    var count = 0;
    var curDate = startDate;
    while (curDate <= endDate) {
        count++;
        curDate = addDays(curDate, 1);
    }
    return count;
}

export const definedRanges = [
    {
        label: "Ma",
        startDate: new Date(),
        endDate: new Date()
    },
    {
        label: "Tegnap",
        startDate: getFromYesterday(new Date()),
        endDate: getToYesterday(new Date())
    },
    {
        label: "Ez a hét",
        startDate: getFirstDayOfWeek(new Date()),
        endDate: getLastDayOfWeek(new Date())
    },
    {
        label: "Múlt hét",
        startDate: getFirstDayOfLastWeek(new Date()),
        endDate: getLastDayOfLastWeek(new Date())
    },
    {
        label: "Ez a hónap",
        startDate: getFirstDayOfThisMonth(new Date()),
        endDate: getLastDayOfThisMonth(new Date())
    },
    {
        label: "Múlt hónap",
        startDate: getFirstDayOfLastMonth(new Date()),
        endDate: getLastDayOfLastMonth(new Date())
    }
];